module.exports = __webpack_public_path__ + "static/media/logo.dbbbe270.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 1209
// module chunks = 0